import {
  FeatureFlagData,
  FeatureFlagTierSetting,
  FeatureFlagType,
} from '../types';

export type BooleanTier = 'growth' | 'pro' | 'ent' | 'entMs';

const BOOLEAN_TIERS: BooleanTier[] = ['growth', 'pro', 'ent', 'entMs'];

export const getBooleanTierSetting = (
  flag: FeatureFlagData,
  tier: BooleanTier,
): FeatureFlagTierSetting | undefined => {
  if (flag.type !== FeatureFlagType.Boolean) {
    return undefined;
  }

  return flag.tierInfo[tier];
};

export const booleanTierHasUpsell = (flag: FeatureFlagData): boolean => {
  if (flag.type !== FeatureFlagType.Boolean) {
    return false;
  }

  return BOOLEAN_TIERS.some(
    (tier) => flag.tierInfo[tier] === FeatureFlagTierSetting.Upsell,
  );
};

export const getBooleanTierDefaultValue = (
  flag: FeatureFlagData,
  tier: BooleanTier,
): boolean | undefined => {
  const setting = getBooleanTierSetting(flag, tier);

  if (setting === FeatureFlagTierSetting.Enabled) {
    return true;
  }

  if (setting === FeatureFlagTierSetting.Disabled) {
    return false;
  }

  return undefined;
};
